import React from 'react';
import { FaHandshake } from 'react-icons/fa';
import './Practicas.css';

const CALENDAR_URL =
  'https://calendar.google.com/calendar/appointments/schedules/' +
  'AcZssZ2P3uv5Z6ZfZZcsJAdp-cqvlmf6w9xOwy1sHV7667x02fwjzFx-nkOa7nKHq_gGBiBT7bz2Z3PC';

export default function Practicas() {
  return (
    <div className="prac-page">
      <div className="prac-header">
        <FaHandshake className="prac-header-icon" />
        <div>
          <h1>Llamadas de práctica</h1>
          <p>Agenda tu sesión de práctica con el equipo de Closer Academy, máximo una clase al día</p>
        </div>
      </div>
      <div className="prac-calendar-wrap">
        <iframe
          src={CALENDAR_URL}
          title="Calendario de Prácticas"
          className="prac-calendar-iframe"
          frameBorder="0"
        />
      </div>
    </div>
  );
}
